var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack220({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.64,3.93h1.72V9.37A5.75,5.75,0,0,1,10.18,11a2.33,2.33,0,0,1-.92,1.2,3,3,0,0,1-1.74.46,2.62,2.62,0,0,1-2-.71,2.89,2.89,0,0,1-.69-2.09L6.5,9.68a2.2,2.2,0,0,0,.22,1,.94.94,0,0,0,.86.47.93.93,0,0,0,.82-.34,2.58,2.58,0,0,0,.24-1.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack220);
export default __webpack_public_path__ + "static/media/Symbolpack_2_20.3278bffa5fa4324a7103adc150346b41.svg";
export { ForwardRef as ReactComponent };